import React, { useEffect, useRef, useState } from "react";
import EditProduct from "./EditProduct";
import { useShowAlert } from "../../../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { usePermission } from "../../../context/PermissionContext";
import Messages from "../../../constants/Messages";
import DeleteModal from "../../../constants/DeleteModal";
import BarcodeGenerator from "./BarCode";
import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../../utils/baseUtils";
import { useAuth } from "../../../context/AuthProvider";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import Table from "../../../constants/Table";
import EditStock from "../stockbatch/EditStock";
import { toSecondaryQuantity } from "@heartinz/finance";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import AddStockModel from "./AddStockModel";
import StockOut from "../stockbatch/StockOut";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import {
  BarcodeIcon,
  DeleteIcon,
  DotVerticalnIcon,
  EditIcon,
  FileEarmarkTextIcon,
  IdCardIcon,
  NoteIcon,
  ProductIcon,
  StockAddIcon,
  WeightIcon,
} from "../../../constants/Icons";

const ProductDetails = ({
  data,
  onClose,
  onEdit,
  isBtnLoading,
  btnLoading,
  noteSuggests,
  isEditModalOpen,
  setEditModalOpen,
  setDeleteModalOpen,
  handleDelete,
  isDeleteModalOpen,
  brandSuggest,
  setBrandSuggest,
  isStockEditModalOpen,
  closeEditStockModal,
  handleStockUpdate,
  setStockEditModalOpen,
  stockData,
  setStockOutModalOpen,
  setAddStocOpen,
  addStockOpen,
  closeAddStockModel,
  handleupdateListStock,
  handleStockAdd,
  handleCreateStock,
  isStockOutModalOpen,
  closeStockOutModal,
  handleStockTrash,
}) => {
  const showAlert = useShowAlert();
  const { settings, isUser } = useAuth();
  const { permission, viewOption, hasPermission } = usePermission();
  const [onData, setData] = useState(data);
  const [isStockEditData, setStockEditData] = useState([]);
  const [isStockOutData, setStockOutData] = useState("");
  const [isDeleteData, setDeleteData] = useState(null);
  const [isEditData, setEditData] = useState([]);
  const handleUpdateRef = useRef();
  const { checkNetwork } = useNetwork();
  const [finalLandingCost, setFinalLandingCost] = useState([]);
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "inactive":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };
  const defaultConversion = settings?.defaultUnits?.find(
    (u) => u?.unitCode === onData?.unitConfig?.primaryUnitCode,
  );
  // const totalStock = stockData?.reduce(
  //   (total, item) => total + (item?.stockLeft || 0),
  //   0,
  // );
  const searchTag = onData?.searchTag?.split(" ");
  const openDeleteModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDeleteData = () => {
    handleDelete(isDeleteData);
  };
  const handleUpdate = (updatedData, imageFile, trigger = true) => {
    // setProductData((prevProductData) =>
    //   prevProductData?.map((product) =>
    //     product?._id === updatedData?._id ? updatedData : product
    //   )
    // );
    setData({
      ...updatedData,
      mrp: CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
      saleprice: CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
      discount: CurrencyConverter.toSubunit(updatedData?.discount, "INR"),
      baseprice: CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
      taxamount: CurrencyConverter.toSubunit(updatedData?.taxamount, "INR"),
      landingcost: CurrencyConverter.toSubunit(
        updatedData?.landingcost || 0,
        "INR",
      ),
      updated: true,
      brandId: updatedData?.brandData?.title,
    });
    onEdit(updatedData, imageFile, trigger);
  };

  const openAddStockModel = async (product) => {
    if (hasPermission("STOCK", "STOCK:add") || permission === undefined) {
      await getFinalLandingCost(
        product?.stockLinkId,
        product?.stockid,
        product?._id,
      );
      setAddStocOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const getFinalLandingCost = async (stocklinkid, stockid, productid) => {
    try {
      if (!checkNetwork()) return;

      const params = new URLSearchParams();

      // always add productid
      params.append("productid", productid);

      // add stockid only if not null/undefined/empty
      if (stockid !== null && stockid !== undefined && stockid !== "") {
        params.append("stockid", stockid);
      }

      // add stocklinkid only if not null/undefined/empty
      if (
        stocklinkid !== null &&
        stocklinkid !== undefined &&
        stocklinkid !== ""
      ) {
        params.append("stocklinkid", stocklinkid);
      }

      const response = await AxiosInstance.get(
        `module/stock/final-landingcost?${params.toString()}`,
      );
      // const response = await AxiosInstance.get(`module/stock/final-landingcost?${stocklinkid}
      // &stockid=${stockid}&productid=${productid}`);
      setFinalLandingCost(response.data?.results?.finalLandingCost);
      return response.data?.results?.finalLandingCost;
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  const openEditStcokModal = (cItem, cIndex) => {
    if (hasPermission("STOCK", "STOCK:update") || permission === undefined) {
      const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
      setStockEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
        manufacturedate: isValidDate(cItem?.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        expiredate: isValidDate(cItem?.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        cIndex: cIndex,
      });
      setStockEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  useEffect(() => {
    if (data?.updated) {
      setData({
        ...data,
        mrp: CurrencyConverter.toSubunit(data?.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(data?.saleprice, "INR"),
        discount: CurrencyConverter.toSubunit(data?.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(data?.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(data?.taxamount, "INR"),
        landingcost: CurrencyConverter.toSubunit(data?.landingcost || 0, "INR"),
        updated: false,
      });
    } else {
      setData(data);
    }
  }, []);
  return (
    <div>
      {/* <div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center fw-bold text-dark mb-2">
            <i className="ng ng-ng-product-icon fs-5 text-dark"></i>{" "}
            <span className="fs-6 ms-2">{onData?.title}</span>
          </div>
        </div>
      </div> */}
      <div className="row">
        <div className="col-12 col-md-3">
          <div className="card ">
            <div className="card-body">
              <div className="">
                {/* Header with Name + Paylater */}
                <div className="col-lg-12">
                  <div className="shadow-none border-blue mb-0">
                    <div className="card-header bg-light-blue p-2 d-flex justify-content-between align-items-center">
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-center gap-2">
                        <div className="mb-0 fw-600">Product Info</div>

                        {/* Category Dropdown */}
                        {/* <select
                                className="form-select form-select-sm"
                                style={{ width: "140px" }}
                                value={selectedTemplate || ""}
                                onChange={(e) =>
                                  handleTemplateAttach(e.target.value)
                                }
                              >
                                {/* Default label 
                                <option value="">Select Template</option>

                                {templateList.length > 0 ? (
                                  templateList.map((t) => (
                                    <option key={t._id} value={t._id}>
                                      {t.name}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>No Templates</option>
                                )}
                              </select> */}
                      </div>

                      {/* RIGHT SIDE */}
                      <div>
                        <button
                          type="button"
                          className="btn-label-primary  rounded shadow-none border-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            openEditModal(onData);
                          }}
                        >
                          <EditIcon iClass={"me-2 fs-12"} />
                          Edit
                        </button>
                      </div>
                      <div
                        className="toggle-menu-dots dropdown-toggle-split fs-12"
                        data-bs-toggle="dropdown"
                      >
                        <DotVerticalnIcon />
                        <ul className="dropdown-menu dropdown-menu-end shadow">
                          <li
                            className="dropdown-item d-flex gap-2 align-items-center text-danger"
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(onData);
                            }}
                          >
                            <DeleteIcon iClass={"fs-12"} />
                            Delete
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card-body px-2 py-1">
                      <div className="d-flex fw-bold text-dark mb-2 align-items-start">
                        <ProductIcon iClass={"fs-6 text-dark ms-1"} />

                        <span
                          className="fs-6 ms-1"
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "normal",
                            maxWidth: "100%",
                          }}
                        >
                          {onData?.title}
                        </span>
                      </div>
                      <div className="d-flex ">
                        <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "90%" }}
                        >
                          <BarcodeIcon iClass={"fs-5 text-muted"} />
                          <span className="fw-semibold text-muted">
                            SKU Code:
                          </span>
                          <span className="badge rounded-pill bg-label-navy">
                            {onData?.code}
                          </span>
                        </div>
                        {/* <div
                        className="mb-2 d-flex align-items-center gap-2"
                        style={{ flexBasis: "10%" }}
                      >
                        {/* <div className="order-actions ">
                          <button
                            type="button"
                            className="btn-label-primary shadow-none "
                            onClick={(e) => {
                              e.stopPropagation();
                              openEditModal(onData);
                            }}
                          >
                            <i className="ng ng-ng-edit-icon"></i>
                          </button>
                        </div> 
                      </div> */}
                      </div>
                      <div className="d-flex ">
                        <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "100%" }}
                        >
                          <BarcodeIcon iClass={"fs-5 text-muted"} />
                          <span className="fw-semibold text-muted">HSN:</span>
                          {onData?.hsnsac ? (
                            <span className="badge rounded-pill bg-label-retro">
                              {onData.hsnsac}
                            </span>
                          ) : (
                            "-"
                          )}
                        </div>
                        {/* <>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx-rupee fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">MRP:</span>
                    <span className="text-dark">
                      ₹{CurrencyConverter.toCurrency(onData?.mrp || 0, "INR")}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx bx-rupee fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">Sale Price:</span>
                    <span className="text-dark">
                      ₹
                      {CurrencyConverter.toCurrency(
                        onData?.saleprice || 0,
                        "INR"
                      )}
                    </span>
                  </div>
                </> */}

                        {/* <div className="text-end">
                <div
                  className="mb-2 d-flex  align-items-center gap-2"
                  style={{ flexBasis: "10%" }}
                >
                  <div className="order-actions ">
                    <button
                      type="button"
                      className="btn-label-primary shadow-none "
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClickBarcode(onData);
                      }}
                    >
                      <i className="bx bx-barcode"></i>
                    </button>
                  </div>
                </div>
              </div> */}
                      </div>
                      <div className="d-flex">
                        <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "100%" }}
                        >
                          {/* <i className="ng ng-ng-stock-icon fs-5 text-muted"></i> */}
                          <Inventory2OutlinedIcon fontSize="small" />
                          <span className="fw-semibold text-muted">Brand:</span>

                          {onData?.brandId ? (
                            <span className="badge bg-label-kids">
                              {onData?.brandId}
                            </span>
                          ) : (
                            "-"
                          )}
                        </div>

                        {/* <>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx-rupee fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">Base Price:</span>
                    <span className="text-dark">
                      ₹
                      {CurrencyConverter.toCurrency(
                        onData?.baseprice || 0,
                        "INR"
                      )}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx bx-rupee fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">Discount:</span>
                    <span className="text-dark">
                      ₹
                      {CurrencyConverter.toCurrency(
                        onData?.discount || 0,
                        "INR"
                      )}
                    </span>
                  </div>
                </> */}
                      </div>

                      <div className="d-flex">
                        {/* <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "100%" }}
                        >
                          <i className="ng ng-ng-stock-icon fs-5 text-muted"></i>
                          <span className="fw-semibold text-muted">
                            Stock Left:
                          </span>

                          {totalStock ? (
                            <span className="badge bg-label-space">
                              {totalStock} {onData?.totalStockLeftUnit}
                            </span>
                          ) : (
                            "-"
                          )}
                        </div> */}

                        {/* <>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx-file fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">Tax(%):</span>
                    <span className="badge rounded-pill bg-label-peace">{onData?.taxpercentage}%</span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "29%" }}
                  >
                    <i className="bx bx-building fs-5 text-muted"></i>
                    <span className="fw-semibold text-muted">LandingCost:</span>
                    <span className="text-dark">
                      ₹
                      {CurrencyConverter.toCurrency(
                        onData?.landingcost || 0,
                        "INR"
                      )}
                    </span>
                  </div>
                </> */}
                      </div>
                      <div>
                        {onData?.unitConfig && uRLs.UNIT === "true" && (
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "100%" }}
                          >
                            <WeightIcon iClass={"fs-5 text-muted"} />
                            <span className="fw-semibold text-muted">
                              Unit:
                            </span>
                            {defaultConversion?.unitName ? (
                              <span className="badge rounded-pill btn-unit">
                                {defaultConversion?.unitName} (
                                {defaultConversion.unitCode})
                              </span>
                            ) : (
                              "-"
                            )}
                            {/* <div className="">1 {onData?.unitConfig?.primaryUnitCode} 
            = {onData?.unitConfig?.secondaryUnitName ?`${onData?.unitConfig?.conversion} 
            ${onData?.unitConfig?.secondaryUnitCode}`:'1 Unit'}</div> */}
                          </div>
                        )}
                      </div>
                      <div className="d-flex ">
                        <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "100%" }}
                        >
                          <NoteIcon iClass={"fs-5 text-muted"} />
                          <span className="fw-semibold text-muted">Note:</span>

                          {onData?.note && (
                            <span
                              className="badge bg-label-sun text-start"
                              style={{
                                // wordBreak: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                maxWidth: "100%",
                              }}
                            >
                              {onData?.note}
                            </span>
                          )}
                        </div>
                      </div>
                      {onData?.shortName?.length > 0 && (
                        <div className="d-flex ">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexBasis: "100%" }}
                          >
                            <FileEarmarkTextIcon iClass={"fs-5 text-murted"} />
                            <span className="fw-semibold text-muted">
                              ShortName:
                            </span>

                            {onData?.shortName && (
                              <span
                                className="badge bg-label-space text-start"
                                style={{
                                  // wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                  whiteSpace: "normal",
                                  maxWidth: "100%",
                                }}
                              >
                                {onData?.shortName}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="d-flex">
                        <div
                          className="mb-2 d-flex align-items-center gap-2"
                          style={{ flexBasis: "100%" }}
                        >
                          <IdCardIcon iClass={"fs-5 text-muted"} />
                          <span className="fw-semibold text-muted">
                            Status:
                          </span>

                          {onData?.status && (
                            <span
                              className={`badge rounded-pill ${getColor(onData?.status)}`}
                            >
                              {onData?.status.charAt(0).toUpperCase() +
                                onData?.status.slice(1).toLowerCase()}
                            </span>
                          )}
                        </div>
                        {/* <div
                className="mb-2 d-flex align-items-center gap-2"
                style={{ flexBasis: "10%" }}
              >
                <div className="order-actions ">
                  <button
                    type="button"
                    className="btn-label-danger shadow-none "
                    onClick={(e) => {
                      e.stopPropagation();
                      openDeleteModal(onData);
                    }}
                  >
                    <i className="ng ng-ng-delete-icon"></i>
                  </button>
                </div>
              </div> */}
                      </div>
                      {searchTag?.length > 0 && (
                        <div className="d-flex">
                          <div
                            className="mb-2 d-flex align-items-center gap-2"
                            style={{ flexWrap: "wrap" }}
                          >
                            {/* <i className="bx bx-id-card fs-5 text-muted"></i>
                <span className="fw-semibold text-muted">Status:</span> */}
                            {searchTag?.map((item) => (
                              <span className="tag-chip gap-1">
                                <LocalOfferIcon fontSize="samll" />
                                {item}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="d-flex justify-content-end">
                      <div className="order-actions ">
                        {/* <button
                type="button"
                className="btn-label-primary shadow-none me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  openEditModal(onData);
                }}
              >
                <i className="ng ng-ng-edit-icon"></i>
              </button> */}
                        {/* <button
                type="button"
                className="btn-label-primary shadow-none me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickBarcode(onData);
                }}
              >
                <i className="bx bx-barcode"></i>
              </button> */}
                        {/* <button
                type="button"
                className="btn-label-danger shadow-none me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  openDeleteModal(onData);
                }}
              >
                <i className="ng ng-ng-delete-icon"></i>
              </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Phone */}
        </div>

        <div className="col-12 col-md-9 ps-0">
          <div className="card mb-2">
            <div className="card-body p-0">
              <div className="d-flex justify-content-end gap-2 p-2 pb-0">
                {/* <div className="order-actions">
                  <button
                    type="button"
                    className="btn-label-danger shadow-none me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      openDeleteModal(onData);
                    }}
                  >
                    <i className="ng ng-ng-delete-icon"></i>
                  </button>
                </div> */}
                {/* <div className="order-actions">
              <button
                type="button"
                className="btn-label-primary shadow-none "
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickBarcode(onData);
                }}
              >
                <i className="bx bx-barcode"></i>
              </button>
            </div> */}
                {/* <div className="order-actions">
              <button
                type="button"
                className="btn-label-primary shadow-none "
                onClick={(e) => {
                  e.stopPropagation();
                  openEditModal(onData);
                }}
              >
                <i className="ng ng-ng-edit-icon"></i>
              </button>
            </div> */}
                <button
                  onClick={() => openAddStockModel(data)}
                  ref={handleUpdateRef}
                  type="button"
                  className="btn btn-label-teal text-right shadow-none"
                >
                  <StockAddIcon /> New Stock
                </button>

                {/* <div
                  className="toggle-menu-dots dropdown-toggle-split"
                  data-bs-toggle="dropdown"
                >
                  <i className="bx bx-dots-vertical "></i>
                  <ul className="dropdown-menu dropdown-menu-end shadow-lg">
                    <li
                      className="dropdown-item d-flex gap-2 align-items-center text-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDeleteModal(onData);
                      }}
                    >
                      <i className="ng ng-ng-delete-icon  fs-18"></i>
                      Delete
                    </li>
                  </ul>
                </div> */}
              </div>
              {stockData?.length > 0 ? (
                <Table
                  wrapperClass="stock-table mt-0"
                  data={stockData}
                  trClass={true}
                  onRowClick={(item, index) => {
                    if (isUser.stype === "MAIN") {
                      openEditStcokModal(item, index);
                    } else {
                      openDeleteTrashModal(item, index);
                    }
                  }}
                  columns={[
                    {
                      label: "MRP",
                      render: (item) => (
                        <span className="badge bg-label-fall rounded-pill text-right">
                          {formatCurrencyFun(item?.mrp)}
                        </span>
                      ),
                    },
                    {
                      label: "Sale Price",
                      render: (item) => (
                        <span className="badge bg-label-food rounded-pill text-right">
                          {formatCurrencyFun(item?.saleprice)}
                        </span>
                      ),
                    },
                    {
                      label: "Tax(%)",
                      render: (item) => (
                        <span className="badge rounded-pill bg-label-peace">
                          {item.taxpercentage}%
                        </span>
                      ),
                    },
                    {
                      label: "LandingCost",
                      render: (item) => (
                        <span className="badge bg-label-secondary rounded-pill text-right">
                          {formatCurrencyFun(item?.landingcost)}
                        </span>
                      ),
                    },
                    viewOption(
                      "stockSettings",
                      "isManufactureAndExpiryDates",
                    ) && {
                      label: "Date",
                      render: (item) => (
                        <>
                          <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                            MFD :{" "}
                            {item?.manufacturedate
                              ? DateConverter.ISOToDisplayFormat(
                                  DateConverter.convertToTimeZone(
                                    item?.manufacturedate,
                                    isUser.timezone,
                                  ),
                                ).date
                              : ""}
                          </small>
                          <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                            EXP :{" "}
                            {item?.expiredate
                              ? DateConverter.ISOToDisplayFormat(
                                  item.expiredate,
                                  isUser.timezone,
                                ).date
                              : ""}
                          </small>
                        </>
                      ),
                    },
                    {
                      label: "Stock Left",
                      render: (item) => (
                        <>
                          {" "}
                          <span className="badge bg-label-space mx-1">
                            {Number(
                              item?.isSecondaryUnit
                                ? secondaryQuanity(
                                    item.stockLeft,
                                    item?.unitConfig,
                                  )
                                : item?.stockLeft,
                            )}{" "}
                            <span className="font-11 ms-1">
                              {(() => {
                                const unitCode = item?.isSecondaryUnit
                                  ? item?.unitConfig?.secondaryUnitCode
                                  : item?.unitConfig?.primaryUnitCode;

                                return unitCode !== "unit" ? unitCode : "";
                              })()}
                            </span>
                          </span>
                          /{" "}
                          <span className="badge bg-label-spring">
                            {Number(
                              item?.isSecondaryUnit
                                ? secondaryQuanity(
                                    item.stockIn,
                                    item?.unitConfig,
                                  )
                                : item?.stockIn,
                            )}
                            {""}
                            <span className="font-11 ms-1">
                              {(() => {
                                const unitCode = item?.isSecondaryUnit
                                  ? item?.unitConfig?.secondaryUnitCode
                                  : item?.unitConfig?.primaryUnitCode;

                                return unitCode !== "unit" ? unitCode : "";
                              })()}
                            </span>
                          </span>
                        </>
                      ),
                    },
                    {
                      label: "Action",
                      render: (item, index) => (
                        <div className="order-actions  d-flex align-items-center justify-content-center">
                          {isUser.stype === "MAIN" && (
                            <>
                              {/* <button
                              type="button"
                              className="btn btn-sm btn-label-teal  shadow-none me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditStcokModal(item, index);
                              }}
                            >
                              <i className="ng ng-ng-edit-icon"></i>
                            </button>

                            <button
                            type="button"
                            className="btn btn-sm btn-label-teal  shadow-none me-2 "
                            onClick={(e) => {
                              e.stopPropagation();
                              openStockInModal(item, index);
                            }}
                          >
                            <i className="ng ng-ng-add-icon"></i>{" "}
                            Stock
                          </button> */}
                            </>
                          )}
                          {/* <button
                          type="button"
                          className="btn btn-sm btn-label-teal  shadow-none me-2 "
                          onClick={(e) => {
                            e.stopPropagation();
                            openStockInModal(item, index);
                          }}
                        >
                          <i className="ng ng-ng-add-icon"></i>{" "}
                          Stock
                        </button> */}
                          <button
                            type="button"
                            className="btn-label-primary shadow-none me-2 "
                            onClick={(e) => {
                              e.stopPropagation();
                              openEditStcokModal(item, index);
                            }}
                          >
                            <EditIcon />
                          </button>
                          <button
                            type="button"
                            className="btn-label-primary shadow-none me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClickBarcode(item);
                            }}
                          >
                            <BarcodeIcon />
                          </button>
                          {Number(
                            item?.isSecondaryUnit
                              ? secondaryQuanity(
                                  item?.stockLeft,
                                  item?.unitConfig,
                                )
                              : item?.stockLeft,
                          ) > 0 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-label-danger shadow-none"
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteTrashModal(item, index);
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          )}
                        </div>
                      ),
                    },
                  ].filter(Boolean)}
                />
              ) : (
                <div className={`table-responsive mt-2`}>
                  <table className="table align-middle mb-0">
                    <thead className="table-light text-center">
                      <tr>
                        <th>MRP</th>
                        <th>Sale Price</th>
                        <th>Tax(%)</th>
                        <th>LandingCost</th>
                        <th>Date</th>
                        <th>Stock Left</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          {" "}
                          <span className="badge bg-label-fall rounded-pill text-right">
                            {formatCurrencyFun(onData?.mrp)}
                          </span>
                        </td>
                        <td className="text-center">
                          {" "}
                          <span className="badge bg-label-food rounded-pill text-right">
                            {formatCurrencyFun(onData?.saleprice)}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="badge rounded-pill bg-label-peace">
                            {onData.taxpercentage}%
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-label-secondary rounded-pill text-right">
                            {formatCurrencyFun(onData?.landingcost)}
                          </span>
                        </td>
                        <td className="text-center">
                          {" "}
                          <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                            MFD :{" "}
                          </small>{" "}
                          <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                            EXP :{" "}
                          </small>
                        </td>
                        <td className="text-center">-</td>
                        <td className="text-center">
                          <div className="order-actions  d-flex align-items-center justify-content-center">
                            {" "}
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2 "
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditModal(onData);
                              }}
                            >
                              <EditIcon />
                            </button>
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClickBarcode(onData);
                              }}
                            >
                              <BarcodeIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isEditModalOpen && (
        <EditProduct
          editData={isEditData}
          onClose={onClose}
          onEdit={handleUpdate}
          isBtnLoading={isBtnLoading}
          noteSuggests={noteSuggests}
          brandSuggest={brandSuggest}
          setBrandSuggest={setBrandSuggest}
          fromProductView={true}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          onClose={() => setDeleteModalOpen(false)}
          onConfirm={handleDeleteData}
          isLable={" Product " + isDeleteData?.title}
          isBtnLoading={btnLoading}
          showConfirmCheckbox={true}
        />
      )}
      {isStockOutModalOpen && (
        <StockOut
          data={isStockOutData}
          onClose={closeStockOutModal}
          onEdit={handleStockTrash}
          isBtnLoading={btnLoading}
        />
      )}
      {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
        <BarcodeGenerator
          barcodeValue={selectedBarcode.code}
          product={selectedBarcode}
          onClose={() => setShowBarcodeModal(false)}
        />
      )}
      {isStockEditModalOpen && (
        <EditStock
          editData={isStockEditData}
          onClose={closeEditStockModal}
          onEdit={handleStockUpdate}
          isBtnLoading={btnLoading}
        />
      )}
      {addStockOpen && (
        <AddStockModel
          onclose={closeAddStockModel}
          onData={data}
          stokData={stockData}
          onUpdate={handleupdateListStock}
          onStockAdd={handleStockAdd}
          isBtnLoading={btnLoading}
          onStockCreate={handleCreateStock}
          finalLand={finalLandingCost}
        />
      )}
    </div>
  );
};

export default ProductDetails;
